"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertServerEnv = void 0;
function assertServerEnv(functionName) {
    if (typeof window !== 'undefined') {
        throw new Error(`"${functionName}" should only be used on server side.`);
    }
}
exports.assertServerEnv = assertServerEnv;
//# sourceMappingURL=assertServerEnv.js.map